import {type Line} from '../../util/plotHelpers/types';

/**
 * Splits display lines for the chart and legend.
 * - Legend lines leave out aux lines (bands and areas), which are drawn but
 *   are not runs.
 * - Visible lines have data or NaN points; hidden lines have neither and are
 *   listed separately in the legend.
 */
export function partitionLines(lines: Line[]): {
  hiddenLines: Line[];
  legendLines: Line[];
  visibleLines: Line[];
} {
  const legendLines = lines.filter(line => !line.aux);
  const visibleLines: Line[] = [];
  const hiddenLines: Line[] = [];
  for (const line of lines) {
    const hasData =
      line.data.length > 0 ||
      (line.nanPoints != null && line.nanPoints.length > 0);
    if (hasData) {
      visibleLines.push(line);
    } else {
      hiddenLines.push(line);
    }
  }
  return {hiddenLines, legendLines, visibleLines};
}
